import { createFileRoute } from '@tanstack/react-router';

import { fileLinesSearch, loadWalletMessages, loadWalletScreens, walletConfirmationLinesScreen } from '@/modules/wallet/route';
import { lazyScreen } from '@/shared/screen';

// Transações do arquivo retorno (`router.tsx:1397-1401`), irmã do detalhe e sem menu.
export const Route = createFileRoute('/_app/gestao-carteira/carteiras/arquivos/$fileId/retorno')({
  validateSearch: fileLinesSearch,
  staticData: { screen: walletConfirmationLinesScreen },
  loader: loadWalletMessages,
  component: lazyScreen(loadWalletScreens, 'WalletConfirmationLinesScreen'),
});
